// extracted by mini-css-extract-plugin
module.exports = {"button":"_6f25b66c20--button--2k_8w","blue":"_6f25b66c20--blue--1xQc8"};